


































import { Component, Vue } from 'vue-property-decorator'
import store from '../store'
import axios from 'axios'

@Component({
  name: 'Settings',
  components: {}
})
export default class extends Vue {
  created() {
    console.log('created')
  }

  enableNotificationsTelegram = true
  notificationsTelegramAll = true
  async myfunction() {
    const answer = await axios.get(process.env.VUE_APP_BASE_URL + 'api/')
    console.log(answer)
  }
}
